export const GTM_CONFIG = [
  {
    gtmId: "GTM-MD4CWRKW",
    paths: ["/", "/thank-you"],
  },
  {
    gtmId: "GTM-N3VNF5DC",
    paths: ["/zerto", "/zerto/thank-you"],
  },
];
